import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconShoppingCart(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 2a1 1 0 0 0 0 2h2.446l.656 3.436a.997.997 0 0 0 .015.077l1.366 7.15v.001a2.73 2.73 0 0 0 .917 1.579 2.59 2.59 0 0 0 1.71.614h7.936a2.59 2.59 0 0 0 1.71-.614c.48-.405.801-.966.917-1.58l.002-.007 1.309-7.191A1 1 0 0 0 21 6.285H7.919l-.664-3.473A1 1 0 0 0 6.273 2H3Zm6.448 12.29L8.3 8.286h11.5l-1.093 6.005v.003a.73.73 0 0 1-.24.42.59.59 0 0 1-.393.143H10.082a.59.59 0 0 1-.393-.143.73.73 0 0 1-.241-.423v-.002Zm.242 5.937a.125.125 0 0 0 .037-.084.125.125 0 0 0-.037-.085.203.203 0 0 0-.145-.058.203.203 0 0 0-.144.058.125.125 0 0 0-.037.085c0 .024.01.056.037.084.027.03.079.059.144.059.066 0 .118-.03.145-.059Zm-1.963-.084c0-.982.771-1.857 1.818-1.857 1.048 0 1.819.875 1.819 1.857 0 .981-.771 1.857-1.819 1.857-1.047 0-1.818-.876-1.818-1.857Zm10.963.084a.125.125 0 0 0 .037-.084.125.125 0 0 0-.037-.085.203.203 0 0 0-.145-.058.203.203 0 0 0-.144.058.125.125 0 0 0-.037.085c0 .024.01.056.037.084.027.03.079.059.145.059.065 0 .117-.03.144-.059Zm-1.963-.084c0-.982.771-1.857 1.819-1.857 1.047 0 1.818.875 1.818 1.857 0 .981-.771 1.857-1.819 1.857-1.047 0-1.818-.876-1.818-1.857Z"
  }));
}
IconShoppingCart.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconShoppingCart.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconShoppingCart as default };
